var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-subtitle"},[_c('TextSimple',{attrs:{"size":"xs","color":"grey"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }